import BankAccountActivitiesTable from './activities-detail-table';

export default BankAccountActivitiesTable;
